/**
 * TARRANT BURST GENERATOR v1.0
 * Generative radial patterns for Tarrant Divination Company
 * 
 * Usage in Shopify Liquid:
 *   <div id="burst-container"></div>
 *   <script src="{{ 'tarrant-burst.js' | asset_url }}"></script>
 *   <script>
 *     TarrantBurst.render('burst-container', {
 *       seed: 'For a New Love',   // intention text or any string
 *       size: 300,                 // pixel size
 *       color: '#111111',          // stroke color
 *       opacity: 0.08,             // container opacity
 *       style: 'mixed'             // mixed|radial|spiral|scatter|convergent|asymmetric
 *     });
 *   </script>
 * 
 * Or generate raw SVG string:
 *   const svgString = TarrantBurst.toSVG('For a New Love', { size: 500, color: '#111111' });
 */

(function(global) {
  'use strict';

  function seededRandom(seed) {
    var s = typeof seed === 'string' ? hashString(seed) : seed;
    return function() {
      s = (s * 16807 + 0) % 2147483647;
      return (s - 1) / 2147483646;
    };
  }

  function hashString(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function generateBurst(seed, style) {
    style = style || 'mixed';
    var numericSeed = typeof seed === 'string' ? hashString(seed) : seed;
    var rng = seededRandom(numericSeed);
    var elements = [];

    var cx = 250 + (rng() - 0.5) * 60;
    var cy = 250 + (rng() - 0.5) * 60;
    var density = 40 + Math.floor(rng() * 80);
    var minRadius = 15 + rng() * 40;
    var maxRadius = 100 + rng() * 140;
    var angularSpread = 0.3 + rng() * 0.7;
    var startAngle = rng() * Math.PI * 2;
    var asymmetry = rng() * 0.6;
    var gapChance = 0.05 + rng() * 0.15;
    var curvature = (rng() - 0.5) * 0.3;
    var dashLengthBase = 4 + rng() * 12;
    var dashGapBase = 3 + rng() * 8;
    var strokeWidth = 0.8 + rng() * 1.2;

    var styles = ['radial','radial','radial','spiral','scatter','convergent','asymmetric'];
    var substyle = style === 'mixed' ? styles[Math.floor(rng() * styles.length)] : style;

    for (var i = 0; i < density; i++) {
      var t = i / density;
      var angle;

      if (substyle === 'radial') {
        angle = startAngle + t * Math.PI * 2 * angularSpread + (rng() - 0.5) * 0.15;
      } else if (substyle === 'spiral') {
        angle = startAngle + t * Math.PI * 2 * 1.2 + t * curvature * 3;
      } else if (substyle === 'scatter') {
        angle = rng() * Math.PI * 2;
      } else if (substyle === 'convergent') {
        angle = startAngle + t * Math.PI * 2 + Math.sin(t * Math.PI * 4) * 0.3;
      } else if (substyle === 'asymmetric') {
        var sector = rng() < 0.6 ? 0 : 1;
        angle = startAngle + (sector * Math.PI) + rng() * Math.PI * angularSpread;
      } else {
        angle = startAngle + t * Math.PI * 2;
      }

      if (rng() < gapChance) continue;

      var rayMinR = minRadius * (0.7 + rng() * 0.6);
      var rayMaxR = maxRadius * (0.6 + rng() * 0.8 + (asymmetry * Math.sin(angle * 2)));
      var rayDashLen = dashLengthBase * (0.5 + rng() * 1.2);
      var rayGapLen = dashGapBase * (0.5 + rng() * 1.2);
      var elementType = rng();

      if (elementType < 0.6) {
        var numDashes = 1 + Math.floor((rayMaxR - rayMinR) / (rayDashLen + rayGapLen));
        for (var d = 0; d < numDashes; d++) {
          var r1 = rayMinR + d * (rayDashLen + rayGapLen);
          var r2 = Math.min(r1 + rayDashLen, rayMaxR);
          if (r1 >= rayMaxR) break;
          if (rng() < 0.1) continue;
          var aj = (rng() - 0.5) * 0.04;
          var a = angle + aj + curvature * (r1 / maxRadius);
          elements.push({
            type: 'line',
            x1: cx + Math.cos(a) * r1, y1: cy + Math.sin(a) * r1,
            x2: cx + Math.cos(a + (rng() - 0.5) * 0.02) * r2,
            y2: cy + Math.sin(a + (rng() - 0.5) * 0.02) * r2,
            sw: strokeWidth * (0.6 + rng() * 0.8)
          });
        }
      } else if (elementType < 0.8) {
        var a2 = angle + curvature * 0.5;
        elements.push({
          type: 'line',
          x1: cx + Math.cos(a2) * rayMinR, y1: cy + Math.sin(a2) * rayMinR,
          x2: cx + Math.cos(a2 + curvature * 0.3) * rayMaxR,
          y2: cy + Math.sin(a2 + curvature * 0.3) * rayMaxR,
          sw: strokeWidth * (0.4 + rng() * 0.5)
        });
      } else if (elementType < 0.9) {
        var numDots = 2 + Math.floor(rng() * 5);
        for (var dd = 0; dd < numDots; dd++) {
          var r = rayMinR + (rayMaxR - rayMinR) * (dd / numDots) + rng() * 6;
          var a3 = angle + (rng() - 0.5) * 0.06;
          elements.push({
            type: 'circle',
            cx: cx + Math.cos(a3) * r, cy: cy + Math.sin(a3) * r,
            r: 0.5 + rng() * 1.5
          });
        }
      } else {
        var numTicks = 2 + Math.floor(rng() * 4);
        for (var dt = 0; dt < numTicks; dt++) {
          var rt = rayMinR + (rayMaxR - rayMinR) * (dt / numTicks);
          var perpA = angle + Math.PI / 2;
          var tickLen = 2 + rng() * 5;
          var midX = cx + Math.cos(angle) * rt;
          var midY = cy + Math.sin(angle) * rt;
          elements.push({
            type: 'line',
            x1: midX - Math.cos(perpA) * tickLen, y1: midY - Math.sin(perpA) * tickLen,
            x2: midX + Math.cos(perpA) * tickLen, y2: midY + Math.sin(perpA) * tickLen,
            sw: strokeWidth * 0.6
          });
        }
      }
    }

    if (rng() < 0.3) {
      elements.push({ type: 'circle', cx: cx, cy: cy, r: 2 + rng() * 6 });
    }

    return elements;
  }

  // Generate SVG string
  function toSVG(seed, opts) {
    opts = opts || {};
    var size = opts.size || 500;
    var color = opts.color || '#111111';
    var style = opts.style || 'mixed';
    var elements = generateBurst(seed, style);

    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" width="' + size + '" height="' + size + '">\n';
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (el.type === 'line') {
        svg += '  <line x1="' + el.x1.toFixed(2) + '" y1="' + el.y1.toFixed(2) +
          '" x2="' + el.x2.toFixed(2) + '" y2="' + el.y2.toFixed(2) +
          '" stroke="' + color + '" stroke-width="' + el.sw.toFixed(2) +
          '" stroke-linecap="round"/>\n';
      } else if (el.type === 'circle') {
        svg += '  <circle cx="' + el.cx.toFixed(2) + '" cy="' + el.cy.toFixed(2) +
          '" r="' + el.r.toFixed(2) + '" fill="' + color + '"/>\n';
      }
    }
    svg += '</svg>';
    return svg;
  }

  // Render into a DOM element
  function render(containerId, opts) {
    opts = opts || {};
    var container = typeof containerId === 'string'
      ? document.getElementById(containerId)
      : containerId;
    if (!container) return;

    var seed = opts.seed || 'tarrant';
    var svgString = toSVG(seed, opts);
    container.innerHTML = svgString;

    if (opts.opacity !== undefined) {
      container.style.opacity = opts.opacity;
    }
  }

  // Render all elements with data-burst attribute
  function autoRender() {
    var els = document.querySelectorAll('[data-burst]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      render(el, {
        seed: el.getAttribute('data-burst'),
        size: parseInt(el.getAttribute('data-burst-size')) || 200,
        color: el.getAttribute('data-burst-color') || '#111111',
        opacity: parseFloat(el.getAttribute('data-burst-opacity')) || 1,
        style: el.getAttribute('data-burst-style') || 'mixed'
      });
    }
  }

  // Auto-init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoRender);
  } else {
    autoRender();
  }

  // Public API
  global.TarrantBurst = {
    generate: generateBurst,
    toSVG: toSVG,
    render: render,
    autoRender: autoRender,
    hashString: hashString
  };

})(typeof window !== 'undefined' ? window : this);
